var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prep-adherence',[_c('p',[_vm._v(" Here’s a resource if you’d like to consider going back on PrEP: "),_c('external-link',{attrs:{"href":"https://preplocator.org/","target":"_blank"}},[_vm._v("https://preplocator.org/")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }